export default {
    // Ticket shared to other boards/lists (the ticket stays on its own board)
    TARGETS: () => `/taskShare/targets`,
    GET: (taskId) => `/taskShare/${taskId}`,
    SHARE: (taskId) => `/taskShare/${taskId}`,
    UNSHARE: (shareId) => `/taskShare/share/${shareId}`,
    MOVE: (taskId) => `/taskShare/${taskId}/move`,
    SETTING: (userId) => `/taskShare/setting/${userId}`,
};
